import React, { useCallback } from 'react';
import CurrencyFormat from 'react-currency-format';
import { Col, FormGroup, Input, Label, Row } from 'reactstrap';
import PropTypes from 'prop-types';
import { Field } from 'formik';
import classNames from 'classnames';

function FormCurrencyInputFieldInner(props) {
  const {
    label,
    placeholder,
    form,
    field,
    disabled,
    invalid,
    maxLength,
    className,
    inputClassName,
    required,
    labelVariant,
    prefix,
    decimalScale,
    allowDecimals,
    icon,
    iconClassName,
    suffix,
    isErrorVisible,
  } = props;

  const error = form.errors[field.name];
  const touched = form.touched[field.name];
  const hasError = error && touched;

  const isBordered = labelVariant === 'bordered';
  const labelClassName = classNames({
    'form-input-field-label': isBordered,
    'form-currency-input-field-label': !isBordered,
    'label-required': required,
  });

  const formGroupClassName = classNames('form-group', {
    'form-group--bordered-label': isBordered,
  });

  const handleValueChange = useCallback(
    (values) => {
      // Use onValueChange instead of onChange for CurrencyFormat
      // This gives us the clean numeric value without formatting
      form.setFieldValue(field.name, values.value);
    },
    [form, field.name],
  );

  return (
    <Row className={className}>
      <Col>
        <div className={formGroupClassName}>
          {icon && (
            <div
              className={`input-icon ${iconClassName || 'icon-form-input-field-image-wrapper'} ${
                disabled ? 'input-icon__disabled' : ''
              }`}
            >
              <img src={icon} alt="Input icon" />
            </div>
          )}
          <Label
            className={`${labelClassName} ${disabled ? 'form-input-field-label__disabled' : ''}`}
          >
            {label}
          </Label>
          <FormGroup>
            <CurrencyFormat
              className={classNames(inputClassName, {
                'is-invalid': hasError,
              })}
              thousandSeparator={true}
              allowNegative={false}
              prefix={prefix}
              decimalScale={allowDecimals ? decimalScale : 0}
              fixedDecimalScale={allowDecimals}
              invalid={invalid || hasError}
              customInput={Input}
              placeholder={placeholder}
              maxLength={maxLength}
              value={field.value || ''}
              disabled={form.isSubmitting || disabled}
              onBlur={() => form.setFieldTouched(field.name, true)}
              onValueChange={handleValueChange}
              suffix={suffix}
            />
            {(form.submitCount > 0 || touched) && error && isErrorVisible && (
              <label className="form-input-field__label error-label">{error}</label>
            )}
          </FormGroup>
        </div>
      </Col>
    </Row>
  );
}

function FormCurrencyInputFieldFixed(props) {
  return <Field {...props} component={FormCurrencyInputFieldInner} />;
}

FormCurrencyInputFieldFixed.defaultProps = {
  placeholder: '',
  disabled: false,
  label: '',
  className: '',
  inputClassName: 'form-control',
  invalid: false,
  maxLength: null,
  required: false,
  labelVariant: 'default',
  prefix: '£',
  decimalScale: 2,
  allowDecimals: false,
  suffix: '',
  isErrorVisible: true,
};

FormCurrencyInputFieldFixed.propTypes = {
  label: PropTypes.string,
  placeholder: PropTypes.string,
  disabled: PropTypes.bool,
  className: PropTypes.string,
  inputClassName: PropTypes.string,
  invalid: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
  maxLength: PropTypes.number,
  required: PropTypes.bool,
  labelVariant: PropTypes.oneOf(['default', 'bordered']),
  prefix: PropTypes.string,
  suffix: PropTypes.string,
  decimalScale: PropTypes.number,
  allowDecimals: PropTypes.bool,
  isErrorVisible: PropTypes.bool,
};

export default FormCurrencyInputFieldFixed;
